import type { IconProps } from "@/types";

export const TransitEnterExitIcon = ({ size = 20, ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 21"
      {...props}
    >
      <g clipPath="url(#clip0_1805_5727)">
        <path
          fill="currentColor"
          d="M12.083 15.34H6.667C5.75 15.34 5 14.59 5 13.673V8.257c0-.692.558-1.25 1.25-1.25s1.25.558 1.25 1.25v2.725l4.958-4.809a1.215 1.215 0 011.7.017c.467.467.467 1.225.009 1.7l-4.875 4.95h2.791c.692 0 1.25.558 1.25 1.25s-.558 1.25-1.25 1.25z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1805_5727">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="translate(0 .34)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};
